

import MainBody from './MainBody'

//console.info('Home Class') ;


const Home = () => {


 
    return (
        <section >
            <MainBody/>
        </section>
    )
}

export default Home